// import { HttpClient } from '@angular/common/http';
// import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/share';

import { Injectable } from '@angular/core';

import { Api } from '../api/api';

@Injectable()
export class Devices {

  old:any = [
    {
       "atv":true,
       "display":"6.21’’ | 18.7:9",
       "camera":"12MP+12MP+W13MP (traseira) / 8MP (frontal)",
       "processador":"OctaCore 2.84GHz",
       "memoriaRam":"3550 mAh",
       "memoriaInt":"128GB",
       "bateria":"3550 mAh",
       "versao":"Android 9.0",
       "fabricante":"LG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1565274325508/-1",
       "modelo":"G8S ThinQ",
       "create":1564063600872
    },
    {
       "atv":true,
       "bateria":"2716 mAh",
       "camera":"Dual 12MP wide angle / 7MP",
       "display":"5.8” HD Oled Display",
       "memoriaInt":"64/256 GB",
       "memoriaRam":"3GB",
       "processador":"Apple A11 Bionic Hexa Core 64 bits",
       "versao":"iOS 11",
       "fabricante":"APPLE",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b914c713c83cb4bcdd5a9d6/-1",
       "modelo":"iPhone X",
       "create":0
    },
    {
       "atv":true,
       "display":"6.0” HD+ (18.5:9)",
       "camera":"13MP / 5MP",
       "processador":"Quad Core 1.4 GHz (Qualcomm MSM8917)",
       "memoriaRam":"2GB",
       "memoriaInt":"32GB + slot",
       "bateria":"3300 mAh",
       "versao":"Android 8.1",
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5bf759af7929786120aff390/-1",
       "modelo":"GALAXY J4+",
       "create":1542937007094
    },
    {
       "atv":true,
       "display":"6” FHD+ (18:9)",
       "camera":"Dual 12 + 5 MP / 8MP",
       "processador":"Octa Core 1.8 GHz (Snapdragon 636)",
       "memoriaRam":"4GB",
       "memoriaInt":"64GB + slot",
       "bateria":"3000 mAh + Turbo Power",
       "versao":"Android 8.1.0 Oreo",
       "fabricante":"MOTOROLA",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5bbcb511d5a83009ee9a2172/-1",
       "modelo":"MOTO Z3 PLAY STYLE",
       "create":0
    },
    {
       "atv":true,
       "display":"6.0” HD+ (18.5:9)",
       "camera":"Dual 13 + 5MP / 8MP",
       "processador":"Quad Core 1.4 GHz (Qualcomm MSM8917)",
       "memoriaRam":"3GB",
       "memoriaInt":"32GB + slot",
       "bateria":"3300 mAh",
       "versao":"Android 8.1",
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5bf758c67929786120aff377/-1",
       "modelo":"GALAXY J6+",
       "create":1542936774243
    },
    {
       "atv":true,
       "bateria":"3600 mAh",
       "camera":"13MP / 13MP",
       "display":"5.5” FHD sAMOLED",
       "memoriaInt":"64GB + slot",
       "memoriaRam":"3GB",
       "processador":"Octa Core 1.6 GHz (Exynos 7870)",
       "versao":"Android 7.0",
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b914c713c83cb4bcdd5a8ff/-1",
       "modelo":"GALAXY J7 PRO",
       "create":0
    },
    {
       "atv":true,
       "display":"5.3” HD+ (16:9)",
       "camera":"13MP / 5MP",
       "processador":"Octa Core 1.5 GHz (MediaTek MT6750)",
       "memoriaRam":"3GB",
       "memoriaInt":"32GB + slot",
       "bateria":"2880 mAh",
       "versao":"Android 7.1.2",
       "fabricante":"LG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5bc018dd6f371f539128f0ff/-1",
       "modelo":"K11 PLUS",
       "create":0
    },
    {
       "atv":true,
       "display":"5.7” QHD",
       "camera":"Dual 13MP / 5MP",
       "processador":"Quad Core (Dual 2.3 + 1.6 GHz) (Snapdragon 821)",
       "memoriaRam":"4GB",
       "memoriaInt":"64GB + slot",
       "bateria":"3300 mAh",
       "versao":"Android 7.0",
       "fabricante":"LG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5bbf6ce2797f4b08337d0334/-1",
       "modelo":"G6 64GB",
       "create":0
    },
    {
       "atv":true,
       "display":"5.5” FHD+ (18:9)",
       "camera":"16MP / 5MP",
       "processador":"Octa Core (1.5 GHz + 1.0 GHz) (MediaTek MT6750S)",
       "memoriaRam":"4GB",
       "memoriaInt":"64GB + slot",
       "bateria":"2890 mAh",
       "versao":"Android 8.1.0",
       "fabricante":"LG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5bbcb6a7d5a83009ee9a217f/-1",
       "modelo":"Q7+",
       "create":0
    }
  ]
  off:any = [
    {
       "atv":true,
       "bateria":"1821 mAh",
       "camera":"12MP / 7MP",
       "display":"4.7” HD True Tone Display",
       "memoriaInt":"256 GB",
       "memoriaRam":"2GB",
       "processador":"Apple A11 Bionic Hexa Core 64 bits",
       "versao":"iOS 11",
       "fabricante":"APPLE",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b914c713c83cb4bcdd5a8fb/-1",
       "modelo":"iPhone 8 256GB",
       "create":0
    },
    {
       "atv":true,
       "bateria":"1821 mAh",
       "camera":"12MP / 7MP",
       "display":"4.7” HD True Tone Display",
       "memoriaInt":"64 GB",
       "memoriaRam":"2GB",
       "processador":"Apple A11 Bionic Hexa Core 64 bits",
       "versao":"iOS 11",
       "fabricante":"APPLE",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b914c713c83cb4bcdd5a8fc/-1",
       "modelo":"iPhone 8 64GB",
       "create":0
    },
    {
       "atv":true,
       "bateria":"2691 mAh",
       "camera":"Dual 12MP / 7MP",
       "display":"5.5” FHD True Tone Display",
       "memoriaInt":"64 GB",
       "memoriaRam":"3GB",
       "processador":"Apple A11 Bionic Hexa Core 64 bits",
       "versao":"iOS 11",
       "fabricante":"APPLE",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b914c713c83cb4bcdd5a8fd/-1",
       "modelo":"iPhone 8 Plus 64GB",
       "create":0
    },
    {
       "atv":true,
       "bateria":"2691 mAh",
       "camera":"Dual 12MP / 7MP",
       "display":"5.5” FHD True Tone Display",
       "memoriaInt":"256 GB",
       "memoriaRam":"3GB",
       "processador":"Apple A11 Bionic Hexa Core 64 bits",
       "versao":"iOS 11",
       "fabricante":"APPLE",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b914c713c83cb4bcdd5a8fe/-1",
       "modelo":"iPhone 8 Plus 256 GB",
       "create":0
    },
    {
       "atv":true,
       "bateria":"1500 mAh",
       "camera":"5MP / VGA",
       "display":"4.0” WVGA",
       "memoriaInt":"8GB + slot",
       "memoriaRam":"1GB",
       "processador":"Quad Core 1.5 GHz",
       "versao":"Android 5.1",
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b914c713c83cb4bcdd5a98a/-1",
       "modelo":"GALAXY J1 MINI",
       "create":0
    },
    {
       "atv":true,
       "bateria":"1715 mAh",
       "camera":"12MP / 5MP",
       "display":"4.7” HD",
       "memoriaInt":"32GB",
       "memoriaRam":"2GB",
       "processador":"DualCore 1.84GHz 64 bits",
       "versao":"iOS 11",
       "fabricante":"APPLE",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b914c713c83cb4bcdd5a9a8/-1",
       "modelo":"iPhone 6S 32GB",
       "create":0
    },
    {
       "atv":true,
       "bateria":"1960 mAh",
       "camera":"12MP / 7MP",
       "display":"4.7” HD",
       "memoriaInt":"32 GB",
       "memoriaRam":"2GB",
       "processador":"Apple A10 Fusion Quad Core 64 bits",
       "versao":"iOS 11",
       "fabricante":"APPLE",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b914c713c83cb4bcdd5a9a9/-1",
       "modelo":"iPhone 7 32GB",
       "create":0
    },
    {
       "atv":true,
       "bateria":"1960 mAh",
       "camera":"12MP / 7MP",
       "display":"4.7” HD",
       "memoriaInt":"128 GB",
       "memoriaRam":"2GB",
       "processador":"Apple A10 Fusion Quad Core 64 bits",
       "versao":"iOS 11",
       "fabricante":"APPLE",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b914c713c83cb4bcdd5a9aa/-1",
       "modelo":"iPhone 7 128GB",
       "create":0
    },
    {
       "atv":true,
       "bateria":"1960 mAh",
       "camera":"12MP / 7MP",
       "display":"4.7” HD",
       "memoriaInt":"256 GB",
       "memoriaRam":"2GB",
       "processador":"Apple A10 Fusion Quad Core 64 bits",
       "versao":"iOS 11",
       "fabricante":"APPLE",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b914c713c83cb4bcdd5a9ab/-1",
       "modelo":"iPhone 7 256GB",
       "create":0
    },
    {
       "atv":true,
       "bateria":"2900 mAh",
       "camera":"Dual 12MP / 7MP",
       "display":"5.5” HD",
       "memoriaInt":"32 GB",
       "memoriaRam":"3GB",
       "processador":"Apple A10 Fusion Quad Core 64 bits",
       "versao":"iOS 11",
       "fabricante":"APPLE",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b914c713c83cb4bcdd5a9ac/-1",
       "modelo":"iPhone 7 PLUS 32GB",
       "create":0
    },
    {
       "atv":true,
       "bateria":"2900 mAh",
       "camera":"Dual 12MP / 7MP",
       "display":"5.5” HD",
       "memoriaInt":"128 GB",
       "memoriaRam":"3GB",
       "processador":"Apple A10 Fusion Quad Core 64 bits",
       "versao":"iOS 11",
       "fabricante":"APPLE",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b914c713c83cb4bcdd5a9ad/-1",
       "modelo":"iPhone 7 PLUS 128GB",
       "create":0
    },
    {
       "atv":true,
       "bateria":"2900 mAh",
       "camera":"Dual 12MP / 7MP",
       "display":"5.5” HD",
       "memoriaInt":"256 GB",
       "memoriaRam":"3GB",
       "processador":"Apple A10 Fusion Quad Core 64 bits",
       "versao":"iOS 11",
       "fabricante":"APPLE",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b914c713c83cb4bcdd5a9ae/-1",
       "modelo":"iPhone 7 PLUS 256GB",
       "create":0
    },
    {
       "atv":true,
       "bateria":"3000 mAh",
       "camera":"12MP / 8MP",
       "display":"5.8” QHD sAMOLED",
       "memoriaInt":"64GB + slot",
       "memoriaRam":"4GB",
       "processador":"Octa Core (2.3 GHz + 1.7 GHz) (Exynos 8895)",
       "versao":"Android 8.0",
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b914c713c83cb4bcdd5a9bd/-1",
       "modelo":"GALAXY S8",
       "create":0
    },
    {
       "atv":true,
       "bateria":"2700 mAh",
       "camera":"13MP / 5MP",
       "display":"5.3” IPS HD",
       "memoriaInt":"32GB + slot",
       "memoriaRam":"2GB",
       "processador":"Octa Core 1.5 GHz (Mediatek MT6750)",
       "versao":"Android 7.0",
       "fabricante":"LG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b914c713c83cb4bcdd5a9c6/-1",
       "modelo":"K10 NOVO",
       "create":0
    },
    {
       "atv":true,
       "bateria":"2600 mAh",
       "camera":"8MP / 5MP",
       "display":"5.0” qHD TFT",
       "memoriaInt":"16GB + slot",
       "memoriaRam":"1.5 GB",
       "processador":"Quad Core 1.4 GHz (Mediatek MT6737T)",
       "versao":"Android 6.0.1",
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b914c713c83cb4bcdd5a9cb/-1",
       "modelo":"GALAXY J2 PRIME",
       "create":0
    },
    {
       "atv":true,
       "display":"6.1” QHD+ (19.5:9)",
       "camera":"Dual 16MP / 8MP",
       "processador":"Octa Core 2.8 GHz (Snapdragon 845)",
       "memoriaRam":"4GB",
       "memoriaInt":"64GB + slot",
       "bateria":"2890 mAh",
       "versao":"Android 8.0 Oreo",
       "fabricante":"LG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b97d0642a8118071b5fd756/-1",
       "modelo":"G7",
       "create":0
    },
    {
       "atv":true,
       "display":"5.7” HD+ IPS",
       "camera":"13MP / 5MP",
       "processador":"Quad Core 1.4 GHz (Snapdragon 425)",
       "memoriaRam":"2GB",
       "memoriaInt":"16GB + slot",
       "bateria":"4000 mAh",
       "versao":"Android 8.0 Oreo",
       "fabricante":"MOTOROLA",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b97d0de2a8118071b5fd75a/-1",
       "modelo":"Moto E5",
       "create":0
    },
    {
       "atv":true,
       "display":"5.7” HD+",
       "camera":"13MP / 8MP",
       "processador":"Octa Core 1.4 GHz (Snapdragon 430)",
       "memoriaRam":"3GB",
       "memoriaInt":"32GB + slot",
       "bateria":"4000 mAh + Turbo Power",
       "versao":"Android 8.0 Oreo",
       "fabricante":"MOTOROLA",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b97d1112a8118071b5fd75c/-1",
       "modelo":"MOTO G6 PLAY",
       "create":0
    },
    {
       "atv":true,
       "display":"5.7” FHD+",
       "camera":"Dual 12 + 5MP / 8MP",
       "processador":"Octa Core 1.8 GHz (Snapdragon 450)",
       "memoriaRam":"3GB",
       "memoriaInt":"32GB + slot",
       "bateria":"3000 mAh + Turbo Power",
       "versao":"Android 8.0 Oreo",
       "fabricante":"MOTOROLA",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b97d1522a8118071b5fd75e/-1",
       "modelo":"Moto G6",
       "create":0
    },
    {
       "atv":true,
       "display":"5.9” FHD+",
       "camera":"Dual 12 + 5MP / 8MP",
       "processador":"Octa Core 2.2 GHz (Snapdragon 630)",
       "memoriaRam":"4GB",
       "memoriaInt":"64GB + slot",
       "bateria":"3200 mAh + Turbo Power",
       "versao":"Android 8.0 Oreo",
       "fabricante":"MOTOROLA",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b97d1a72a8118071b5fd760/-1",
       "modelo":"MOTO G6 PLUS",
       "create":0
    },
    {
       "atv":true,
       "display":"6” FHD+ sAMOLED (16:9)",
       "camera":"Dual 16 + 5MP / 24MP",
       "processador":"Octa Core 1.8 GHz (Snapdragon 450)",
       "memoriaRam":"4GB",
       "memoriaInt":"64GB + slot",
       "bateria":"3500 mAh",
       "versao":"Android 8.0 Oreo",
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b97d1d32a8118071b5fd762/-1",
       "modelo":"Galaxy A6 Plus",
       "create":0
    },
    {
       "atv":true,
       "display":"5.6” FHD+ sAMOLED (18.5:9)",
       "camera":"16MP / Dual 16 + 8MP",
       "processador":"Octa Core (Dual 2.2GHz + Hexa 1.6GHz)",
       "memoriaRam":"4GB",
       "memoriaInt":"64GB + slot",
       "bateria":"3000 mAh",
       "versao":"Android 7.1",
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b97d21b2a8118071b5fd764/-1",
       "modelo":"GALAXY A8",
       "create":0
    },
    {
       "atv":true,
       "display":"6” FHD+ sAMOLED (18.5:9)",
       "camera":"16MP / Dual 16 + 8MP",
       "processador":"Octa Core (Dual 2.2GHz + Hexa 1.6GHz)",
       "memoriaRam":"4GB",
       "memoriaInt":"64GB + slot",
       "bateria":"3500 mAh",
       "versao":"Android 7.1",
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b97d2732a8118071b5fd766/-1",
       "modelo":"GALAXY A8 +",
       "create":0
    },
    {
       "atv":true,
       "display":"5.5” HD sAMOLED",
       "camera":"13MP / 5MP",
       "processador":"Quad Core 1.4 GHz (Exynos 7570)",
       "memoriaRam":"2GB",
       "memoriaInt":"32GB + slot",
       "bateria":"3000 mAh",
       "versao":"Android 8.0",
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b97d2992a8118071b5fd768/-1",
       "modelo":"GALAXY J4",
       "create":0
    },
    {
       "atv":true,
       "display":"5.8” QHD+ sAMOLED (18.5:9)",
       "camera":"12MP / 8MP.",
       "processador":"Octa Core (2.8 GHz + 1.7 GHz) (Snapdragon 845)",
       "memoriaRam":"4GB",
       "memoriaInt":"128GB + slot",
       "bateria":"3000 mAh",
       "versao":"Android 8.0 Oreo",
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b97d3762a8118071b5fd76e/-1",
       "modelo":"GALAXY S9",
       "create":0
    },
    {
       "atv":true,
       "display":"6.2” QHD+ sAMOLED (18.5:9)",
       "camera":"Dual 12 + 12MP / 8MP",
       "processador":"Octa Core (2.8 GHz + 1.7 GHz) (Snapdragon 845)",
       "memoriaRam":"6GB",
       "memoriaInt":"128GB + slot",
       "bateria":"3500 mAh",
       "versao":"Android 8.0 Oreo",
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5b97d3aa2a8118071b5fd770/-1",
       "modelo":"GALAXY S9+",
       "create":0
    },
    {
       "atv":true,
       "display":"6” HD+ sAMOLED (18.5:9)",
       "camera":"16 + 5MP / 16MP",
       "processador":"Octa Core 1.8 GHz (Snapdragon 450)",
       "memoriaRam":"4GB",
       "memoriaInt":"64GB + slot",
       "bateria":"3500 mAh",
       "versao":"Android 8.0",
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5bbb8f4b46eed7514f2f2061/-1",
       "modelo":"GALAXY J8",
       "create":0
    },
    {
       "atv":true,
       "display":"5.6” HD+ sAMOLED (16:9)",
       "camera":"13MP / 8MP",
       "processador":"Octa Core 1.6 GHz (Exynos 7870)",
       "memoriaRam":"2GB",
       "memoriaInt":"32GB + slot",
       "bateria":"3000 mAh",
       "versao":"Android 8.0",
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5bbb8f9e46eed7514f2f2067/-1",
       "modelo":"GALAXY J6 DTV",
       "create":0
    },
    {
       "atv":true,
       "display":"6.4” FHD True Tone Display",
       "camera":"Dual 12MP / 8MP",
       "processador":"Octa Core (2.8 GHz + 1.7 GHz) Snapdragon 845",
       "memoriaRam":"6GB",
       "memoriaInt":"128 GB",
       "bateria":"4000 mAh",
       "versao":"Android 8.1.0",
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5bbb8fea46eed7514f2f2069/-1",
       "modelo":"GALAXY NOTE 9",
       "create":0
    },
    {
       "atv":true,
       "display":"6.1” HD Liquid Retina",
       "camera":"12MP / 7MP",
       "processador":"Apple A12 Bionic Hexa Core 64 bits",
       "memoriaRam":"3GB",
       "memoriaInt":"64 GB",
       "bateria":"2942 mAh",
       "versao":"iOS 12",
       "fabricante":"APPLE",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5be58665bc81b5332952cc34/-1",
       "modelo":"iPhone XR 64GB",
       "create":1541768805318
    },
    {
       "atv":true,
       "display":"6.1” HD Liquid Retina",
       "camera":"12MP / 7MP",
       "processador":"Apple A12 Bionic Hexa Core 64 bits",
       "memoriaRam":"3GB",
       "memoriaInt":"128GB",
       "bateria":"2942 mAh",
       "versao":"iOS 12",
       "fabricante":"APPLE",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5be586e0bc81b5332952cc36/-1",
       "modelo":"iPhone XR 128GB",
       "create":1541768928954
    },
    {
       "atv":true,
       "display":"5.8” HD sAMOLED Display",
       "camera":"Dual 12MP / 7MP",
       "processador":"Apple A12 Bionic Hexa Core 64 bits",
       "memoriaRam":"4GB",
       "memoriaInt":"64 GB",
       "bateria":"2658 mAh",
       "versao":"iOS 12",
       "fabricante":"APPLE",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5be5882107702233737d9a41/-1",
       "modelo":"iPhone Xs 64GB",
       "create":1541769249376
    },
    {
       "atv":true,
       "display":"6.5” HD sAMOLED Display",
       "camera":"Dual 12MP / 7MP",
       "processador":"Apple A12 Bionic Hexa Core 64 bits",
       "memoriaRam":"4GB",
       "memoriaInt":"64GB",
       "bateria":"3174 mAh",
       "versao":"iOS 12",
       "lancamento":false,
       "oferta":false,
       "fabricante":"APPLE",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5be5888b07702233737d9a43/-1",
       "modelo":"iPhone XS MAX 64GB",
       "create":1541769355379
    },
    {
       "atv":true,
       "display":"5.34” FWVGA+ (18:9)",
       "camera":"8MP / 5MP",
       "processador":"Quad Core 1.4 GHz (Snapdragon 425)",
       "memoriaRam":"1GB",
       "memoriaInt":"16GB + Slot",
       "bateria":"2100 mAh",
       "versao":"Android 8.0 Oreo Go Edition",
       "fabricante":"MOTOROLA",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5be5892107702233737d9a45/-1",
       "modelo":"MOTO E5 PLAY",
       "create":1541769505075
    },
    {
       "atv":true,
       "display":"6.0” FHD+ sAMOLED (18.5:9)",
       "camera":"Tripla 24 + 5 + 8MP / 24MP",
       "processador":"Octa Core (Dual 2.2GHz + Hexa 1.6GHz)",
       "memoriaRam":"4GB",
       "memoriaInt":"128GB + slot",
       "bateria":"3300 mAh",
       "versao":"Android 8.0",
       "lancamento":false,
       "oferta":true,
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5c0eba1d77021129b6f4bae8/-1",
       "modelo":"GALAXY A7 128GB",
       "create":1544469021246
    },
    {
       "atv":true,
       "display":"6.3” FHD+ sAMOLED (18.5:9)",
       "camera":"Quadrupla  24 + 5 + 10 + 8MP Frontal 24MP",
       "processador":"Octa Core (Quad 2.2 + 1.8 GHz) (Snapdragon 660)",
       "memoriaRam":"6GB",
       "memoriaInt":"128GB + slot (até 512GB)",
       "bateria":"3800 mAh",
       "versao":"Android 8.0 Oreo",
       "lancamento":true,
       "oferta":false,
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5c647206c4ec2a4f7b104086/-1",
       "modelo":"Galaxy A9",
       "create":1550086662874
    },
    {
       "atv":true,
       "display":"5.7\"",
       "camera":"16MP (traseira) / 8MP (frontal)",
       "processador":"OctaCore 2.0GHz",
       "memoriaRam":"3GB",
       "memoriaInt":"32GB + slot (até 2TB)",
       "bateria":"3000 mAh",
       "versao":"Android 9.0",
       "fabricante":"LG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/5c871e1394f0874f7ecf8db8/-1",
       "modelo":"K12 PLUS",
       "create":1552358931251
    },
    {
       "atv":true,
       "display":"5.8” FHD+ Dynamic AMOLED",
       "camera":"Dual 12 + 16MP / 10MP",
       "processador":"Octa Core (Exynos 9820)",
       "memoriaRam":"6GB",
       "memoriaInt":"128GB + slot",
       "bateria":"3100 mAh",
       "versao":"Android 9.0 Pie",
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1570808096018/-1",
       "modelo":"GALAXY S10E",
       "create":1554410725684
    },
    {
       "atv":true,
       "display":"6.1” QHD+ Dynamic AMOLED",
       "camera":"Tri 12 + 12 + 16MP / 10MP",
       "processador":"Octa Core (Exynos 9820)",
       "memoriaRam":"8GB",
       "memoriaInt":"128GB + slot",
       "bateria":"3400 mAh",
       "versao":"Android 9.0 Pie",
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1570807711524/-1",
       "modelo":"GALAXY S10",
       "create":1554412154799
    },
    {
       "atv":true,
       "display":"6.4” QHD+ Dynamic AMOLED",
       "camera":"Tri 12 + 12 + 16MP /  Dual 8 + 10MP",
       "processador":"Octa Core (Exynos 9820)",
       "memoriaRam":"8GB",
       "memoriaInt":"128GB + slot",
       "bateria":"4100 mAh",
       "versao":"Android 9.0 Pie",
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1570807887522/-1",
       "modelo":"GALAXY S10 PLUS",
       "create":1554412725259
    },
    {
       "atv":true,
       "display":"4.95” FWVGA+ (18:9)",
       "camera":"8MP / 5MP",
       "processador":"QuadCore 1.1 GHz (MediatekMT6739)",
       "memoriaRam":"1GB",
       "memoriaInt":"8GB + slot",
       "bateria":"2000 mAh",
       "versao":"Android 8.1 Go",
       "fabricante":"POSITIVO",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1565282926393/-1",
       "modelo":"Twist 2 Go",
       "create":1554929232414
    },
    {
       "atv":true,
       "display":"6.2” HD+ IPS LCD(19:9)",
       "camera":"13MP / 5MP",
       "processador":"Exynos 7884B Octa-Core (2x1,6 GHz + 6x 1,35Ghz)",
       "memoriaRam":"2GB",
       "memoriaInt":"32GB + slot (até 512GB)",
       "bateria":"3400 mAh",
       "versao":"Android 9.0 (Pie)",
       "lancamento":true,
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1575075732171/-1",
       "modelo":"GALAXY A10",
       "create":1557407751369
    },
    {
       "atv":true,
       "display":"Display Infinito-V Super AMOLED de 6,4”",
       "camera":"13 + 5MP",
       "processador":"Octa-core (Dual 1.6GHz, Hexa 1.35GHz)",
       "memoriaRam":"3GB",
       "memoriaInt":"32GB",
       "bateria":"4000mAh",
       "versao":"Android 9.0 (Pie)",
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1570807482813/-1",
       "modelo":"GALAXY A20",
       "create":1558550904971
    },
    {
       "atv":true,
       "display":"6.2\" | 19:9",
       "camera":"13MP+2MP (traseira) / 13MP (frontal)",
       "processador":"MediaTek Octa-Core 2GHz",
       "memoriaRam":"3GB",
       "memoriaInt":"32GB",
       "bateria":"3500 mAh",
       "versao":"MediaTek Octa-Core 2GHz",
       "fabricante":"LG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1565274303133/-1",
       "modelo":"K12 MAX",
       "create":1560911573691
    },
    {
       "atv":true,
       "display":"6.47\" | 19,5:9",
       "camera":"40MP + 20MP + 8MP + TOF (traseira) / 32MP (frontal)",
       "processador":"OctaCore (2x 2.6GHz + 2x 1.92GHz + 4x 1.8GHz)",
       "memoriaRam":"8GB",
       "memoriaInt":"256GB",
       "bateria":"4200mAh",
       "versao":"Android 9.1",
       "fabricante":"HUAWEI",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1565273281343/-1",
       "modelo":"P30 Pro",
       "create":1564065975242
    },
    {
       "atv":true,
       "display":"6.15\" | 19,25:9",
       "camera":"24MP + 8MP + 2MP (traseira) /32MP (frontal)",
       "processador":"OctaCore (4x 2.2GHz + 4x 1.7GHz)",
       "memoriaRam":"4GB",
       "memoriaInt":"128GB",
       "bateria":"3340mAh",
       "versao":"Android 9.0",
       "fabricante":"HUAWEI",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1565274231000/-1",
       "modelo":"P30 LITE",
       "create":1564066736184
    },
    {
       "atv":true,
       "display":"6.4\"",
       "camera":"13MP + 5MP + 16MP (traseira) / 12MP (frontal)",
       "processador":"Snapdragon 675 Octa-Core (2x 2.0GHz + 6x 1.8GHz)",
       "memoriaRam":"4GB",
       "memoriaInt":"128GB",
       "bateria":"4000 mAh",
       "versao":"Android Pie 9.0",
       "fabricante":"MOTOROLA",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1567605020689/-1",
       "modelo":"ONE ZOOM",
       "create":1567547634518
    },
    {
       "atv":true,
       "display":"6.3\"",
       "camera":"12MP + 16MP + 12MP (Traseira) e 10MP (Frontal)",
       "processador":"Octacore (2X 2.7 GHz + 2x 2.4 GHz + 4x 1.9GHz)",
       "memoriaRam":"8GB",
       "memoriaInt":"256GB",
       "bateria":"3.500 mAh",
       "versao":"Android Pie 9.0",
       "lancamento":true,
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1575075463786/-1",
       "modelo":"GALAXY NOTE 10",
       "create":1568932481273
    },
    {
       "atv":true,
       "display":"6.8\"",
       "camera":"12MP + 16MP + 12MP + ToF (Traseira) e 10MP (Frontal)",
       "processador":"Octacore (2X 2.7 GHz + 2x 2.4 GHz + 4x 1.9GHz)",
       "memoriaRam":"12GB",
       "memoriaInt":"256GB",
       "bateria":"4.300 mAh",
       "versao":"Android Pie 9.0",
       "lancamento":true,
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1575075535245/-1",
       "modelo":"GALAXY NOTE 10+",
       "create":1568932947707
    },
    {
       "atv":true,
       "display":"6.1\"",
       "camera":"13MP + 2MP (traseira) / 8MP (frontal)",
       "processador":"Helio P22 2.0 GHz Octa-Core",
       "memoriaRam":"4GB",
       "memoriaInt":"128GB",
       "bateria":"3000 mAh",
       "versao":"Android Pie 9.0",
       "fabricante":"MOTOROLA",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1569498553384/-1",
       "modelo":"MOTO E6 PLUS",
       "create":1569446954209
    },
    {
       "atv":true,
       "display":"6.1\"",
       "camera":"12MP + 12MP (traseira) / 12MP (frontal)",
       "processador":"A13 Bionic com arquitetura de 64 bits GPU Apple HexaCore",
       "memoriaRam":"4GB",
       "memoriaInt":"64GB / 128GB / 256GB",
       "bateria":"3110 mAh",
       "versao":"iOS 13.0",
       "fabricante":"APPLE",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1575074737555/-1",
       "modelo":"IPHONE 11 64GB",
       "create":1571348874528
    },
    {
       "atv":true,
       "display":"5.8\"",
       "camera":"12MP + 12MP + 12MP (traseira) / 12MP (frontal)",
       "processador":"A13 Bionic com arquitetura de 64 bits GPU Apple HexaCore",
       "memoriaRam":"4GB",
       "memoriaInt":"64GB / 256GB",
       "bateria":"3046 mAh",
       "versao":"iOS 13.0",
       "fabricante":"APPLE",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1575074539564/-1",
       "modelo":"IPHONE 11 PRO 64GB",
       "create":1571349507286
    },
    {
       "atv":true,
       "display":"6.5\"",
       "camera":"12MP + 12MP + 12MP (traseira) / 12MP (frontal)",
       "processador":"A13 Bionic com arquitetura de 64 bits GPU Apple HexaCore",
       "memoriaRam":"4GB",
       "memoriaInt":"64GB / 256GB",
       "bateria":"3969 mAh",
       "versao":"iOS 13.0",
       "fabricante":"APPLE",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1575074839898/-1",
       "modelo":"IPHONE 11 PRO MAX 64GB",
       "create":1571349834132
    },
    {
       "atv":true,
       "display":"6.2\"",
       "camera":"13MP + 8MP + 2MP (traseira) / 8MP (frontal)",
       "processador":"OctaCore 2.0GHz",
       "memoriaRam":"2GB",
       "memoriaInt":"32GB",
       "bateria":"4000 mAh",
       "versao":"Android Pie 9.0",
       "lancamento":true,
       "fabricante":"MOTOROLA",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1575076243935/-1",
       "modelo":"MOTO G8 PLAY",
       "create":1571858288798
    },
    {
       "atv":true,
       "display":"6.3\"",
       "camera":"48MP + 5MP + 16MP (traseira) / 25MP (frontal)",
       "processador":"OctaCore 2.0GHz",
       "memoriaRam":"4GB",
       "memoriaInt":"64GB",
       "bateria":"4000 mAh",
       "versao":"Android Pie 9.0",
       "lancamento":true,
       "fabricante":"MOTOROLA",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1575076119935/-1",
       "modelo":"MOTO G8 PLUS",
       "create":1571860323447
    },
    {
       "atv":true,
       "display":"6.3\"",
       "camera":"13MP + 2MP + 2MP (traseira) / 8MP (frontal)",
       "processador":"MediaTek Helio P70M Octa-Core (4x 2.0GHz + 4x 2.1GHz)",
       "memoriaRam":"4GB",
       "memoriaInt":"64GB",
       "bateria":"4000 mAh",
       "versao":"Android Pie 9.0",
       "lancamento":true,
       "fabricante":"MOTOROLA",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1575075987685/-1",
       "modelo":"ONE MACRO",
       "create":1571860563046
    },
    {
       "atv":true,
       "display":"6.1\"",
       "camera":"13MP + 5MP (traseira) / 13MP (frontal)",
       "processador":"OctaCore 2.0GHz",
       "memoriaRam":"3GB",
       "memoriaInt":"32GB",
       "bateria":"3500 mAh",
       "versao":"Android Pie 9.0",
       "lancamento":true,
       "fabricante":"LG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1575076445725/-1",
       "modelo":"LG K40S",
       "create":1572294813799
    },
    {
       "atv":true,
       "display":"5.5”",
       "camera":"13MP (traseira)/ 5MP (frontal)",
       "processador":"Quad-Core 1.5 GHz",
       "memoriaRam":"2GB",
       "memoriaInt":"32GB",
       "bateria":"3000mAh",
       "versao":"Android 9.0",
       "fabricante":"MOTOROLA",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1575075903889/-1",
       "modelo":"MOTO E6 PLAY",
       "create":1574198488124
    },
    {
       "atv":true,
       "display":"6.4”",
       "camera":"25MP + 8MP + 5MP (traseira)/ 16MP (frontal)",
       "processador":"Octa-Core 1.8 GHz",
       "memoriaRam":"4GB",
       "memoriaInt":"64GB",
       "bateria":"4000mAh",
       "versao":"Android 9.0 Pie",
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1575075253499/-1",
       "modelo":"Galaxy A30S",
       "create":1574198716649
    },
    {
       "atv":true,
       "display":"5”",
       "camera":"8MP / 5MP",
       "processador":"Quad-Core 1.4 GHz",
       "memoriaRam":"1GB",
       "memoriaInt":"16GB",
       "bateria":"2000mAh",
       "versao":"Android 9.0",
       "fabricante":"ZTE",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1574344630030/-1",
       "modelo":"Blade A3 Lite",
       "create":1574344458295
    },
    {
       "atv":true,
       "display":"6.2”",
       "camera":"13MP + 2MP (traseira)/ 8MP (frontal)",
       "processador":"Octa-Core 2GHz",
       "memoriaRam":"2GB",
       "memoriaInt":"32GB",
       "bateria":"4000mAh",
       "versao":"Android 9.0",
       "fabricante":"SAMSUNG",
       "base64":"http://merchan.ibrs.com.br:4008/gridfs/5ce305d104f11e7a23635fafSEC113270832/download/fileAparelhos/fileAparelhos-1575075172788/-1",
       "modelo":"Galaxy A10s",
       "create":1574427621792
    }
 ]
  ordem:any = [
    "iPhone SE 32GB",
    "iPhone 11 Pro Max 256GB",
    "iPhone 11 Pro Max 64GB",
    "iPhone 11 Pro 256GB",
    "iPhone 11 Pro 64GB",
    "iPhone 11 256GB",
    "iPhone 11 128GB",
    "iPhone 11 64GB",
    "iPhone Xs Max 256GB",
    "iPhone Xs 64GB",
    "iPhone Xr 256GB",
    "iPhone Xr 128GB",
    "iPhone Xr 64GB",
    "iPhone X",
    "iPhone 8 Plus 256GB",
    "iPhone 8 Plus 64GB",
    "iPhone 8 256GB",
    "iPhone 8 64GB",
    "iPhone 7 128GB",
    "iPhone 7 32GB",
    "iPhone 6s Plus 64GB",
    "iPhone 6s 64GB",
    "iPhone 6 Plus 16GB",
    "iPhone 6 16GB",
    "iPhone 5S 32GB",
    "Galaxy S20 Ultra 512GB",
    "Galaxy S20 Ultra 128GB",
    "Galaxy S20 Plus",
    "Galaxy S20",
    "Galaxy Note 10 Plus",
    "Galaxy Note 10",
    "Galaxy Note 10 Lite",
    "Galaxy S10 Plus",
    "Galaxy S10",
    "Galaxy S10e",
    "Galaxy S10 Lite",
    "Galaxy A71",
    "Galaxy A51",
    "Galaxy A30s",
    "Galaxy A20s",
    "Galaxy A10s",
    "Galaxy A70",
    "Galaxy A50",
    "Galaxy A50 128GB",
    "Galaxy A30",
    "Galaxy A20",
    "Galaxy A10",
    "Galaxy J4 Core",
    "Galaxy Note 9",
    "Galaxy S9 Plus",
    "Galaxy S9",
    "Galaxy S8",
    "Galaxy A9",
    "Galaxy A8",
    "Galaxy A8 Plus",
    "Galaxy A7 128GB",
    "Galaxy J8",
    "Galaxy J7 Pro",
    "Galaxy J6 Plus",
    "Galaxy J6",
    "Galaxy J2 Prime",
    "Galaxy J1 mini",
    "razr",
    "Moto G8 Power",
    "Moto G8",
    "Moto G8 Plus",
    "Moto G8 Play",
    "MotorolaOne Hyper",
    "MotorolaOne Macro",
    "MotorolaOne Zoom",
    "MotorolaOne Action",
    "MotorolaOne Vision",
    "Moto E6 Plus 64GB",
    "Moto E6 Play",
    "Moto G7 Plus",
    "Moto G7",
    "Moto G7 Power",
    "Moto G7 Play",
    "Moto E5",
    "Moto E5 Play",
    "Moto G6 Plus",
    "Moto G6",
    "Moto G6 Play",
    "G8x ThinQ",
    "G8s ThinQ",
    "K40s",
    "K12 Prime",
    "K12 Max",
    "K12 Plus",
    "K8 Plus",
    "K9 TV",
    "G7 ThinQ",
    "Q7 Plus",
    "K11 Plus",
    "K10 Novo",
  ]

  constructor(public api: Api) {}

  tratCallback(res:any,callback:any){
    console.log(res);
    if(res.status){
      callback({status:true,data:res.data})
    }else{
      callback({status:false,msg:res.error})
    }
  }

  getDevices(callback:any){
    var endpoint = 'ws/api/portal3/listarComparativo';
    var postObj = {
      app_key:'656587484894189',
      app_secret:'54892616987894218599',
      app_cliente:'TIM'
    }
    this.api.request('post',endpoint,postObj,{},(res) => callback(res))
  }

  getData(type){
    return this[type];
  }

}



// WEBPACK FOOTER //
// ./src/providers/devices/devices.ts